import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconInsurance from 'components/icons/IconInsurance';

const styles = () => ({
  root: {
    minHeight: 330,
  },
  iconInsurance: {
    width: 105,
    height: 105,
  },
});

const PatientsDialogInsurancesListEmpty = ({ classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={24}
  >
    <Grid item>
      <IconInsurance className={classes.iconInsurance} />
    </Grid>
    <Grid item>
      <Typography variant="subheading" color="secondary">
        Unfortunately, patient has no insurances for eligibility check
      </Typography>
    </Grid>
  </Grid>
);

PatientsDialogInsurancesListEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconInsurance: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(PatientsDialogInsurancesListEmpty);



// WEBPACK FOOTER //
// ./src/components/patient/PatientsDialog/PatientsDialogInsurancesListEmpty.js